module.exports = __webpack_public_path__ + "img/hint.4f081d2f.png";